import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.132546 0.9375H20.0845V4.15684L12.5746 12.46V18.2597L7.60879 19.9667V12.4516L0.124023 4.1762L0.132546 0.9375ZM1.6286 2.4375L1.62554 3.60016L9.10879 11.8739V17.8649L11.0746 17.1891V11.8823L18.5845 3.57912V2.4375H1.6286Z\" fill=\"#333333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol